/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateNotebookInput {
  /**
  * The name of the notebook
  */
  'name': string;
  /**
  * Optional description
  */
  'description'?: string;
  /**
  * The user creating the notebook
  */
  'createdBy'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdBy",
      "baseName": "createdBy",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateNotebookInput.attributeTypeMap;
  }

  public constructor() {
  }
}

